'use client';
import { createTheme, type ThemeOptions } from '@mui/material/styles';
import { themeSlug } from '@/constants/environment';
import type { ThemeSlug } from '@/types';

/** Duration for the "newly added" highlight animation (ms). */
export const addedHighlightAnimationMs = 6000;

const myThemeOptions = (themeSlug: ThemeSlug, mode: 'light' | 'dark'): ThemeOptions => {
  const options = {
    mymorize: {
      palette: {
        mode,
        primary: { main: mode === 'dark' ? '#ffffff' : '#000000' },
        secondary: { main: mode === 'dark' ? '#454545' : '#8b8b8b' },
      },
    },
    mympu: {
      palette: {
        mode,
        primary: { main: mode === 'dark' ? '#ffffff' : '#000000' },
        secondary: { main: mode === 'dark' ? '#454545' : '#8b8b8b' },
      },
    },
  };

  return options[themeSlug];
};

export const getTheme = (mode: 'light' | 'dark') =>
  createTheme({
    typography: {
      fontFamily: 'var(--font-roboto)',
      h1: {
        fontSize: '1.7rem',
        fontWeight: 700,
        lineHeight: 1.2,
      },
      h2: {
        fontSize: '1.5rem',
        fontWeight: 500,
        lineHeight: 1.2,
      },
      h3: {
        fontSize: '1.2rem',
        lineHeight: 1.2,
        fontWeight: 500,
        textTransform: 'none',
      },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: `
          @keyframes addedHighlight {
            0% {
              background-color: rgba(255, 235, 59, 0.55);
              box-shadow: 0 0 0 2px rgba(255, 193, 7, 0.6);
            }
            70% {
              background-color: rgba(255, 235, 59, 0.2);
              box-shadow: 0 0 0 2px rgba(255, 193, 7, 0.2);
            }
            100% {
              background-color: transparent;
              box-shadow: none;
            }
          }
        `,
      },
    },
    ...myThemeOptions(themeSlug, mode),
  });
